import { Action, Reducer } from 'redux';
import { LOADING, SEARCHVEHICLEANDCHASSISLOADED} from './editAccident.actions';



import { initialState } from './editAccident.state';

export const EditAccidentsReducer: Reducer<any, Action> = (state = initialState, action: any) => {
    let newState = state;
    switch (action.type) {
        case LOADING: newState = { ...newState, loading: true };
            break;
        case SEARCHVEHICLEANDCHASSISLOADED: newState = { ...newState, loading: false, searchResult: action.payload };
            break;
        
    }
    return newState;
};
